import type { ListPurchasesRequest } from '@frontend/api-types';
import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'payments';

const PURCHASES = 'purchases';
const CARDS = 'cards';

export const PAYMENTS_ENDPOINTS = {
  buyCredits: () => formatEndpoint('credits', namespace),
  createSetupIntent: () => formatEndpoint('setup', namespace),
  deleteCard: (id: string) => formatEndpoint(`${CARDS}/${id}`, namespace),
  listCards: () => formatEndpoint(CARDS, namespace),
  listPurchases: ({ clientId }: ListPurchasesRequest) =>
    formatEndpoint(PURCHASES, namespace, { queryParams: { client_id: clientId } }),
  retrievePromotionDetails: (promoCode: string) =>
    formatEndpoint(`promotion-codes/?code=${promoCode}`, namespace, { removeTrailingSlash: true }),
  setupIntentConfirmed: () => formatEndpoint('setup/confirmed', namespace),
  updateCard: (id: string) => formatEndpoint(`${CARDS}/${id}/swap`, namespace),
  updateDefaultCard: (id: string) => formatEndpoint(`${CARDS}/${id}/default`, namespace),
};
